// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-64311bb8] .el-badge__content.is-fixed{top:10px!important;right:16px!important}.el-tabs--bottom .el-tabs__item.is-bottom[data-v-64311bb8]:last-child,.el-tabs--bottom .el-tabs__item.is-top[data-v-64311bb8]:last-child,.el-tabs--top .el-tabs__item.is-bottom[data-v-64311bb8]:last-child,[data-v-64311bb8] .el-tabs--top .el-tabs__item.is-top:last-child{padding-right:20px!important}", ""]);
// Exports
module.exports = exports;
